'use strict';

module.exports = function () {
    // returns true
    // comment
    return true;
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/index.js
 ** module id = 0
 ** module chunks = 0
 **/